export default class VoteError {
    public message: string;

    constructor(message: string) {
        this.message = message;
    }
}